import React from 'react';
import { CheckCircle, AlertCircle, Clock, XCircle } from 'lucide-react';

interface StatusBadgeProps {
  status?: 'draft' | 'submitted' | 'accepted' | 'rejected' | 'error' | 'received' | 'matched' | 'approved' | 'pending' | string;
  size?: 'sm' | 'md' | 'lg';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status = 'pending', size = 'md' }) => {
  const statusConfig: Record<string, { bg: string; text: string; icon: React.ComponentType<any>; label: string }> = {
    draft: {
      bg: 'bg-gray-100',
      text: 'text-gray-800',
      icon: Clock,
      label: 'Draft',
    },
    submitted: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      icon: Clock,
      label: 'Submitted',
    },
    accepted: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      icon: CheckCircle,
      label: 'Accepted',
    },
    rejected: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      icon: XCircle,
      label: 'Rejected',
    },
    error: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      icon: AlertCircle,
      label: 'Error',
    },
    received: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      icon: Clock,
      label: 'Received',
    },
    matched: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      icon: CheckCircle,
      label: 'Matched',
    },
    approved: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      icon: CheckCircle,
      label: 'Approved',
    },
    pending: {
      bg: 'bg-yellow-100',
      text: 'text-yellow-800',
      icon: Clock,
      label: 'Pending',
    },
    processing: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      icon: Clock,
      label: 'Processing',
    },
    completed: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      icon: CheckCircle,
      label: 'Completed',
    },
    failed: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      icon: XCircle,
      label: 'Failed',
    },
  };

  // Get config with fallback to pending if status not found
  const config = statusConfig[status as string] || statusConfig.pending;
  const Icon = config?.icon || Clock;

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base',
  };

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full ${config?.bg || 'bg-gray-100'} ${config?.text || 'text-gray-800'} ${sizeClasses[size]} font-medium`}
    >
      <Icon className="w-4 h-4" />
      {config?.label || 'Unknown'}
    </div>
  );
};
